import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./lightbox.module.scss";

function NavigationNext(props) {
  return (
    <button
      className={classNames(styles.navigation, styles.navigationNext)}
      onClick={props.innerProps.onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="#c9cbcc"
          fillRule="evenodd"
          d="M9.5 21L8 19.5l7.554-7.5L8 4.5 9.5 3l9 9z"
        />
      </svg>
    </button>
  );
}

NavigationNext.propTypes = {
  innerProps: PropTypes.object
};

export default NavigationNext;
